// @ts-nocheck
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

// react-router-dom components

// @mui material components
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

// Material Dashboard 2 React components
import MDBox from "../../components/MDBox";
import MDInputPassword from "../../components/MDInputPassword";
import MDButton from "../../components/MDButton";
import MDSnackbar from "../../components/MDSnackbar";
import MDTypography from "../../components/MDTypography";

import { changePassword } from "../../reducers/auth"
import { setGlobalSnackbar } from "../../reducers/app";

function ChangePasswordForm({ onClose }) {
  let dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const [input, setInput] = useState({
    password: "",
    newPassword: "",
    confirmNewPassword: "",
  })

  const handleClose = (e, reason = '') => {
    if (reason === 'escapeKeyDown' || reason === 'backdropClick') {
      return
    }
    onClose();
  };

  const handleChangeInput = (e) => {
    setErrorMessage(null)
    setInput(prev => {
      if (e.target.name === "country") {
        prev = {
          ...prev,
          state: null,
        }
      }
      return {
        ...prev,
        [e.target.name]: e.target.value
      }
    })
  }
  const handleSubmit = async () => {
    setErrorMessage(null)
    try {
      setLoading(true)
      const resp = await dispatch(changePassword(input))
      dispatch(setGlobalSnackbar({
        open: true,
        title: resp.data.message,
        color: 'success',
        autoHide: true
      }))
      handleClose()
    } catch (e) {
      setLoading(false)
      setErrorMessage(e.data.message)
    }
  }
  console.log(errorMessage)
  return (
    <Dialog onClose={handleClose} open fullWidth maxWidth="xs" disableEscapeKeyDown>
      {errorMessage && (
        <MDSnackbar
          color="error"
          title={errorMessage}
          open
          close={() => setErrorMessage(null)}
        />
      )}
      <DialogTitle>Change Password</DialogTitle>
      <DialogContent>
        <MDBox mt={1} component="form" role="form" autoComplete="off" noValidate>
          <MDBox mb={2}>
            <MDInputPassword disabled={loading} label="Current password" value={input?.password} fullWidth name="password" onChange={handleChangeInput}
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInputPassword disabled={loading} label="New password" value={input?.newPassword} fullWidth name="newPassword" onChange={handleChangeInput}
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInputPassword error={input.newPassword !== input.confirmNewPassword} disabled={loading} label="Confirm new password" value={input?.confirmNewPassword} fullWidth name="confirmNewPassword" onChange={handleChangeInput} />
            {
              input.newPassword !== input.confirmNewPassword && (
                <MDTypography variant="caption" fontWeight="medium" color="error">
                  confirm new password does not match with the new password
                </MDTypography>
              )
            }
          </MDBox>
        </MDBox>
      </DialogContent>
      <DialogActions>
        <MDButton variant="gradient" disabled={loading} color="secondary" onClick={handleClose}>
          Cancel
        </MDButton>
        <MDButton variant="gradient" disabled={input.password !== "" && input.newPassword !== "" && input.newPassword === input.confirmNewPassword && loading} color="primary" onClick={handleSubmit}>
          Submit
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

ChangePasswordForm.propTypes = {
  onClose: PropTypes.func.isRequired
}

export default ChangePasswordForm